// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-lg-block-only,.d-md-block-only,.d-sm-block-only{display:none!important}@media(max-width:767.98px){.d-sm-block-only{display:block!important}}@media(min-width:768px)and (max-width:991.98px){.d-md-block-only{display:block!important}}@media(min-width:992px){.d-lg-block-only{display:block!important}}.rounded-12-5{border-radius:12.5px}@media(min-width:992px){.rounded-lg-12-5{border-radius:12.5px}}", ""]);
// Exports
module.exports = exports;
